// extracted by mini-css-extract-plugin
module.exports = {"bottom_buttons":"_3bwf-c9","bottom_main_buttons":"_2zn3LAa","bottom_additional_buttons":"_39iVtgl"};